import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TwoScorerComingSoon() {
  const { tournamentId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-obsidian text-white flex items-center justify-center px-4 py-12">
      <div className="max-w-3xl w-full border border-zinc-800 rounded-3xl bg-zinc-950/90 p-10 text-center">
        <div className="text-[11px] uppercase tracking-[0.3em] text-court font-bold">Two Scorer Mode</div>
        <h1 className="font-display font-black text-4xl uppercase mt-6">Coming Soon</h1>
        <p className="mt-4 text-sm text-zinc-400 leading-relaxed">
          We’re building a dedicated two-scorer workflow for split-screen scoring and live stat collaboration.
          For now, use the single live scoring experience or manual final score entry.
        </p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row items-center justify-center">
          <button onClick={() => navigate(-1)} className="h-12 px-6 rounded-xl border border-zinc-800 text-zinc-300 hover:text-white uppercase tracking-[0.25em]">
            Back
          </button>
          <button onClick={() => navigate(`/tournaments/${tournamentId}/games`)} className="h-12 px-6 rounded-xl bg-court text-black font-bold uppercase tracking-[0.25em] border-b-4 border-court-deep hover:bg-court-hover">
            Return to Games
          </button>
        </div>
      </div>
    </div>
  );
}
